import { Icons } from '@/components/Shares/Icons';
import { useTheme } from '@/theme/useTheme';
import { Group, Switch, Text, rem, useMatches } from '@mantine/core';
import { IconSun } from '@tabler/icons-react';
import classes from './NavbarBottom.module.css';
export const NavbarBottom = () => {
  const {
    setColorScheme,
    colorScheme
  } = useTheme();
  const sunIcon = <IconSun style={{
    width: rem(16),
    height: rem(16)
  }} stroke={2.5} color="var(--mantine-color-yellow-6)" />;
  const moonIcon = <Icons className="icon-pr-flat-moon-stars" fontSize={16} color="var(--text-dark)" />;
  const size = useMatches({
    sm: 'md',
    lg: 'lg'
  });
  const onLabel = useMatches({
    sm: '',
    lg: <Text span fz={{
      base: 7,
      lg: 8
    }} c="var(--text-dark)" fw={700}>
        DARK
      </Text>
  });
  const offLabel = useMatches({
    sm: '',
    lg: 'LIGHT'
  });
  return <Group justify="space-between" ml={{
    base: rem(-10),
    xl: 0
  }}>
      <Switch defaultChecked size={size} onLabel={onLabel} offLabel={offLabel} color="dark.7" value={colorScheme} classNames={{
      thumb: colorScheme === 'dark' ? classes.thumbDark : classes.thumbLight
    }} onChange={value => setColorScheme(value.target.checked ? 'dark' : 'light')} thumbIcon={colorScheme === 'dark' ? moonIcon : sunIcon} />
      <Text c="dimmed" fz="xs" visibleFrom="lg">
        {'v1.0.0'}
      </Text>
    </Group>;
};